export const floatLabelTheme = {
  colorScheme: {
    light: {
      root: {
        color: 'inherit',
        focusColor: 'inherit',
        activeColor: 'inherit',
        invalidColor: 'inherit',
        transitionDuration: '0.2s',
        fontWeight: '400'
      },
      over: {
        active: {
          top: '0.5rem'
        }
      },
      in: {
        input: {
          paddingTop: '1.5rem',
          paddingBottom: '0.5rem'
        },
        active: {
          top: '1.0rem'
        }
      },
      on: {
        borderRadius: '4px',
        active: {
          background: '{gray.0}',
          padding: '0.25rem 0.5rem'
        }
      }
    },
    dark: {
      root: {
        color: 'inherit',
        focusColor: 'inherit',
        activeColor: 'inherit',
        invalidColor: 'inherit',
        transitionDuration: '0.2s',
        fontWeight: '400'
      },
      over: {
        active: {
          top: '0.5rem'
        }
      },
      in: {
        input: {
          paddingTop: '1.5rem',
          paddingBottom: '0.5rem'
        },
        active: {
          top: '1.0rem'
        }
      },
      on: {
        borderRadius: '4px',
        active: {
          // Form fields are transparent, so this has to match whatever sits
          // behind them -- in dialogs that is gray.800. #1e1e1e was several
          // steps too dark and showed as a patch around the label.
          background: '{gray.800}',
          padding: '0.25rem 0.5rem'
        }
      }
    }
  }
};
